import React, { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Navbar from "../components/Navbar";
import DonationButton from "../components/DonationButton";
import SelectContributorIcon from "../components/SelectContributorIcon";
import { postGroup } from "../services/AnimalSplitCore";
import Prompt from "../components/Prompt";
import { toggleModal } from "../utils/utils";
import { MODAL_ID } from "../constants";
import { useTranslation } from "react-i18next";
import JoinInByIdPopup from "../games/components/JoinInByIdPopup";
import SceneBackground from "../components/scene/SceneBackground";
import "./CreateGroup.css";
import "../containers/ModalTheme.css";
import "../containers/GroupPageCards.css";


export default function CreateGroup(props) {
  const { t, i18n } = useTranslation();
  const { setIsLoading } = props;
  const [eventName, setEventName] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [contributorIconId, setContributorIconId] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const history = useHistory();
  const joinByIdModalId = "join-by-id-modal";

  const isFormValid = useCallback(() => {
    return eventName !== "" && participantName !== "";
  }, [eventName, participantName]);

  const createGroup = useCallback(() => {
    if (!isFormValid()) {
      setFormValidated(true);
      return;
    }
    setIsLoading(true);
    const langToSend =
      i18n.language && i18n.language.startsWith("en") ? "en-US" : i18n.language;
    postGroup(eventName, participantName, contributorIconId, langToSend)
      .then(({ payload }) => {
        const { id: groupId } = payload;
        setIsLoading(false);

        history.push(`${process.env.PUBLIC_URL}/group/${groupId}`);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        toggleModal(MODAL_ID.CONNECTION_ERROR);
      });
  }, [
    eventName,
    contributorIconId,
    participantName,
    i18n.language,
    history,
    isFormValid,
    setIsLoading,
  ]);

  const handleJoinByIdBtnOnClick = useCallback(() => {
    toggleModal(joinByIdModalId);
  }, [joinByIdModalId]);

  return (
    <div className="d-flex flex-column inner-height position-relative overflow-hidden create-group-page as-theme">
      <SceneBackground />
      <Navbar
        rightSlot={<DonationButton className="btn btn-sm as-btn-soft" />}
      />
      <div className="container flex-grow-1 d-flex flex-column justify-content-center">
        <div className="position-relative" style={{ zIndex: 1 }}>
          <div className="row justify-content-center">
            <div className="col-xs-12 col-sm-10 col-md-7 col-lg-5">
              <div className="card shadow-sm as-card create-group-card">
                <div className="card-header d-flex justify-content-between align-items-center as-card-header">
                  <div className="as-card-header-title">
                    <span className="as-icon-badge" aria-hidden="true">🌿</span>
                    <strong>{t("event.create_a_new_event")}</strong>
                  </div>
                </div>

                <div className={`card-body needs-validation ${formValidated ? "was-validated" : ""}`}>
                  <div className="mb-3">
                    <label className="form-label">{t("event.title")}</label>
                    <input
                      type="text"
                      className="form-control"
                      id="eventName"
                      value={eventName}
                      onChange={(e) => setEventName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="participantName" className="form-label">
                      {t("participant.participant_name")}
                    </label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control me-2"
                        id="participantName"
                        value={participantName}
                        onChange={(e) => setParticipantName(e.target.value)}
                        required
                      />
                      <SelectContributorIcon
                        setContributorIconId={setContributorIconId}
                        contributorIconId={contributorIconId}
                      />
                    </div>
                    <div id="participantHelp" className="form-text create-group-help">
                      {t("event.participant_name_prompt")}
                    </div>
                  </div>
                  <div className="create-group-actions">
                    <button
                      className="btn as-btn-primary-gradient"
                      onClick={(e) => {
                        e.preventDefault();
                        createGroup();
                      }}
                    >
                      {t("general.submit")}
                    </button>
                    <button
                      className="btn as-btn-soft"
                      onClick={() => history.push(`${process.env.PUBLIC_URL}/`)}
                    >
                      {t("general.cancel")}
                    </button>
                  </div>

                  <div className="create-group-join">
                    <button
                      className="JoinInByIdButton btn btn-link p-0"
                      onClick={handleJoinByIdBtnOnClick}
                    >
                      {t("event.join_by_id_prompt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <JoinInByIdPopup
        modalId={joinByIdModalId}
        setIsLoading={setIsLoading}
      />
      <Prompt
        modalId={MODAL_ID.CONNECTION_ERROR}
        title="Oops"
        btnTitle="Dismiss"
      >
        <p>There is a connection error</p>
      </Prompt>
    </div>
  );
}
